class ComponentStickyATC extends HTMLElement {
    constructor(config) {
        super();
        this.config = config;
        this.elForm = document.querySelector('add-to-cart-form');
        this.elForm.classList.add('sticky-atc-enabled');
        this.elButton = this.querySelector('button.ProductForm__AddToCart');

        this.cutValueMobile = Number(this.dataset.cutValueMobile);
        this.cutValueDesktop = Number(this.dataset.cutValueDesktop);

        this.mql = window.matchMedia("(max-width: "+window.breakpoints.medium+")");
        this.onDesktop = !this.mql.matches;

        this.amountDisplay = this.querySelector('.amount-display')
  
        window.addEventListener('mediaChange',(e) => {
            this.onDesktop = !this.mql.matches;
        })

        setTimeout(() => {
            
            this.elButton.addEventListener('click', e => {
                e.preventDefault();
                this.elATCButton = this.elForm.querySelector('button[type=submit]');
                this.elATCButton.click();
            })

            this.quantityInput = document.querySelector('quantity-input.quantity-box .quantity-input')
            this.quantityInput.addEventListener('change', e => {
                this.amountDisplay.innerHTML = this.quantityInput.value;
            })
        }, 500)

        window.addEventListener('scroll', (e) => {
            this.checkcutValueMobile();
        })
        this.checkcutValueMobile();
        
    }

    checkcutValueMobile(){
        var cutToUse = this.onDesktop ? this.cutValueDesktop : this.cutValueMobile;

        if(window.scrollY >= cutToUse)
            this.addShow();
        else
            this.removeShow();
    }

    addShow(){
        if(!this.parentElement.classList.contains('show'))
        {
            this.parentElement.classList.add('show');
        }
    }
  
    removeShow(){
        if(this.parentElement.classList.contains('show'))
        {
            this.parentElement.classList.remove('show');
        }
    }
}

customElements.define('sticky-atc', ComponentStickyATC); 